import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { Box, BoxProps } from '../Box/Box';
import { Typography } from '../Typography/Typography';

export interface ValidationErrorProps {
  errors: string[];
  invertColors?: boolean;
  padding?: BoxProps['padding'];
  sx?: BoxProps['sx'];
}

export const ErrorDisplay = (props: ValidationErrorProps) => {
  const { errors, invertColors, padding, sx } = props;

  return (
    <Box
      sx={[
        (theme) => ({
          padding: padding || 2,
          bgcolor: invertColors ? theme.palette.error.contrastText : theme.palette.error.main,
          color: invertColors ? theme.palette.error.main : theme.palette.error.contrastText
        }),
        ...toSxArray(sx)
      ]}>
      <Typography text={errors.join(', ')} align='center' />
    </Box>
  );
};
